import { createContext, useContext } from 'react';
import {
    BOT_NAME,
    DEFAULT_AVATAR_TYPE,
    DEFAULT_PRIMARY_COLOR,
    DEFAULT_TEXT_COLOR,
    type AvatarType,
} from '@/Public/ChatBot/Constants';

interface ChatBotTheme {
    primaryColor: string;
    textColor: string;
    assistantName: string;
    avatarType: AvatarType;
    avatarImageUrl?: string;
}

const ChatBotThemeContext = createContext<ChatBotTheme>({
    primaryColor: DEFAULT_PRIMARY_COLOR,
    textColor: DEFAULT_TEXT_COLOR,
    assistantName: BOT_NAME,
    avatarType: DEFAULT_AVATAR_TYPE,
});

export type { ChatBotTheme };
export const ChatBotThemeProvider = ChatBotThemeContext.Provider;
export const useChatBotTheme = (): ChatBotTheme => useContext(ChatBotThemeContext);
